import { createContext, useState } from 'react';
import api from 'services/api';

export const TipoContatoContext = createContext();

export const TipoContatoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [tipoContato, setTipoContato] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getTipoContato = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: tipoContato?.filter,
        page: tipoContato?.page,
        size: tipoContato?.size,
        order: tipoContato?.order,
        ...payload,
      });
      setTipoContato((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <TipoContatoContext.Provider
      value={{
        getLoading,
        tipoContato,
        getTipoContato,
      }}
    >
      {children}
    </TipoContatoContext.Provider>
  );
};
